import script from "./buildCacheClustersTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./buildCacheClustersTable.vue?vue&type=script&setup=true&lang=ts"

import "./buildCacheClustersTable.vue?vue&type=style&index=0&id=39b7ec4e&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39b7ec4e"]])

export default __exports__